/**
 * Redux Reducer for User Permissions
 */

const initialState = {
  permissionsMap: {},
  loading: false,
  error: null
};

const UserPermissions = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_PERMISSIONS":
      return {
        ...state,
        permissionsMap: action.payload,
        loading: false,
        error: null
      };

    case "CLEAR_USER_PERMISSIONS":
      return initialState;

    case "SET_PERMISSIONS_LOADING":
      return {
        ...state,
        loading: action.payload
      };

    case "SET_PERMISSIONS_ERROR":
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    default:
      return state;
  }
};

export default UserPermissions;
